var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"dragContainer",staticClass:"drag-selection-container",class:{ 'has-photos': _vm.photos.length > 0 }},[(_vm.isDragging)?_c('div',{staticClass:"drag-rectangle",style:(_vm.rectangleStyle)}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }